import { Component, ElementRef, EventEmitter, inject, OnInit, Output, ViewChild } from '@angular/core';
import {INgxMyDpOptions,NgxMyDatePicker, IMyDateModel, NgxMyDatePickerDirective} from '@mksasi/ngx-mydatepicker';
import { EmailValidator, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { enc, SHA512 } from 'crypto-js';
import { AppService } from '../../services/services';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/services/encryption.service';
import { PhotoComponent } from '../photo/photo.component';
import { ValidationService } from 'src/app/validators/validation.service';
import { Modal } from 'bootstrap';
import { animate, style, transition, trigger } from '@angular/animations';
import { ErrorModalComponent } from 'src/app/common/error-modal/error-modal.component';
import { MenuComponent } from '../menus/menu.component';

@Component({
  selector: 'nri-app-pan',
  templateUrl: './pan.component.html',
  styleUrls: ['./pan.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({transform: 'translateY(100%)', opacity: 0}),
          animate('500ms', style({transform: 'translateY(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateY(0)', opacity: 1}),
          animate('500ms', style({transform: 'translateY(100%)', opacity: 0}))
        ])
      ]
    )
  ]
})
export class PanComponent implements OnInit {
  @ViewChild('dp') datePicker: NgxMyDatePickerDirective;
  public userDOB: any;
  public dob: any;
  public dobOptions:  INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
  };
  public defaultMonth: any = {
    defMonth: ''
  };
  public resStatus: string = 'N';
  public gstNumber: string = 'GN';
  public accountStatement: string;
  public politicallyExposed :string;
  public foreignStatus: string = '';
  public marineStatus: string = 'N';
  public relationName: string = '';
  public country: string = '';
  public nriMobile: string = '';
  public nriEmail: string = '';
  obj: any = '';
  pan:string = '';
  isKRA: string = 'Not Found';
  isCKYC: string = 'Not Found';
  kraStatus: string = '';
  ckycStatus: string = '';
  refNo: string = '';
  erefNo: string = '';
  panUpdt: boolean = false;
  panImgempty: boolean = false;
  dobError: boolean = false;
  relationNameEmpty:boolean = false;
  countryEmpty: boolean = false;
  panURL: any;
  countryList:any;
  countryMaster:any;
  countryName: any;
  panSiteName: string = '';
  firstName: string = '';
  middleName: string = '';
  lastName: string = '';
  // title: string = '';
  titleError: boolean = false;
  datas: any;
  emailOTP: any = '';
  mobOTP:any = '';
  otpError: boolean = false;
  otptriggerEmail:boolean = false;
  emailValidatebtn: boolean = false;
  emailCancel: boolean = false;
  otptriggermob:boolean = false;
  mobValidatebtn: boolean = false;
  mobCancel: boolean = false;
  showOTP: boolean;
  reSendOTP: boolean = false;
  rmAssist: boolean = false;
  rmDomain: any;
  email: any;
  rmfullemail: string;
  rmEmail: any = null;
  editedEmail: string;
  oldNriEmail: string;
  oldMobile: string;
  getStatusData: any;
  stageValidated: boolean = false;
  disableEmailEdit: boolean = false;
  disableMobileEdit: boolean = false;
  codeKeyword = 'TeleCode';
  countryCode: any;
  countryCodeError: boolean;
  state:any;
  gst:any;
  ref: any;
  oldCountrycode:any;
  disableCountrycode:boolean = true;
  @ViewChild('photo') faceliveness:PhotoComponent;
  public formBuilder = inject(FormBuilder);
  registerForm = this.formBuilder.group({
    'CustomerName': ['',[Validators.required]],
    'CustomerPan': ['', [Validators.required, ValidationService.panValidator]],
    'userDOB': ['', [Validators.required]],
    // 'NRO': ['', [Validators.required]],
  });
  pansite: any;
  panLoader: boolean = false;
  panVerified: boolean;
  panErrorMessage: string = "PAN is required."
  panNameMessage: string = "Name is required."
  panValidMessage: string = "Please enter a valid PAN for an Individual.";
  aadharStatus:boolean = false;
  mobile:any;
  sessemail:any;
  remarks:string = "";
  panModal: any;
  TCSError:any;
  resumePan: any;
  refExists:boolean = false;
  aadharClickYes: boolean = false;
  aadharClickNo: boolean = false;
  panvalidate:boolean = true;
  panreject: boolean = false;
  utmSource: string = "";
  utmCampaign: string = "";
  utmMedium : string = "";
  ErrorCode:string = "";
  sessCode: string | number | null;
  appStatus: string;
  statusModal:any;
  back: boolean = false;
  selfieNeed:boolean = false;
  isSelfie:boolean = false;
  pep:boolean = true;
  @ViewChild('errorComp') errorComp : ErrorModalComponent;
  ocrSuccess: boolean = false;
  decref: string = "";
  kraclient: string = "";
  ckycclient: string = "";
  @ViewChild('menu') Menu : MenuComponent;
  search : any = {};
  constructor(public myElement: ElementRef, private toastr: ToastrService,private loader: NgxUiLoaderService, private el: ElementRef, private router: Router, private route: ActivatedRoute, private _http: AppService, private http:EncryptionService){
    this.obj = history.state;
    this.nriEmail = this.obj.Email;
    this.nriMobile = this.obj.Mobile;
    this._http.getRefNum().subscribe(data=>{
      this.erefNo = data;
    });
  }

  ngOnInit(){
    const d: Date = new Date();
    this.dobOptions = {
      dateFormat: 'dd/mm/yyyy',
      showTodayBtn: false,
      disableSince: { year: d.getFullYear()-18, month: d.getMonth() + 1, day: d.getDate()+1 },
      disableUntil: { year: d.getFullYear()-100, month: d.getMonth() + 1, day: d.getDate()+1 }
    }
    let m = (d.getMonth()+1).toString();
    let n  = d.getMonth()+1;
    let y = (d.getFullYear()-18).toString();
    if(n < 10){
      m = "0"+m;
    }
    this.defaultMonth =  {
      defMonth:  m+"/"+y
    }
    this.pan = this.obj.PAN;
    this.countryMaster = this._http.countryList;
    this.countryList = this._http.countryList;
    this._http.getStatus().subscribe((data:any)=>{
      this.getStatusData = data;
    })


       if (sessionStorage.getItem("email") !== null) {
      const value = sessionStorage.getItem("email");
      this.sessemail = window.atob(typeof (value) === "string" ? value : "");
    }
    if (sessionStorage.getItem("mob") !== null) {
      const value = sessionStorage.getItem("mob");
      this.mobile = window.atob(typeof (value) === "string" ? value : "");
    }
    // this.mobile = sessionStorage.getItem("mob");
    // this.sessemail = sessionStorage.getItem("email");
    //  if (sessionStorage.getItem("code") !== null) {
    //   const value = sessionStorage.getItem("code");
    //   this.sessCode = window.atob(typeof (value) === "string" ? value : "");
    // }
    this.sessCode = sessionStorage.getItem("code");
    if(sessionStorage.getItem('RmList')){
      this.rmAssist = true;
      this.rmEmail = sessionStorage.getItem('RMEmail');
    }
    if(this.erefNo){
      this.getPanInfo();
      this.overallStatus(this.erefNo);
    }

    this.search = JSON.parse(sessionStorage.getItem('searchParams') || '{}')
    if (this.search?.lgcode) {
      this.rmAssist = true;
      this.rmEmail = this.search?.lgcode;
    }
    
}

  ngAfterViewInit(){
    if(!this.panvalidate){
      setTimeout(() => {
        if(this.faceliveness.selfieImage){
          this.faceliveness.ngOnInit();
        }
      }, 300);
    }

    let utm_source = sessionStorage.getItem("utmSource");
    let utm_medium = sessionStorage.getItem("utmMedium");
    let utm_campaign = sessionStorage.getItem("utmCampaign");

    if(utm_source){
      this.utmSource = utm_source;
    }
    if(utm_medium){
      this.utmMedium = utm_medium;
    }
    if(utm_campaign){
      this.utmCampaign = utm_campaign;
    }
    
  }

panValidation(){
  const today = new Date();
  const dob = new Date(this.dob);
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  if (age < 18) {
    this.toastr.error("Age must be 18 years or above");
    // this.panLoader = false;
    return;   
  }
  if(this.registerForm.controls.CustomerPan.value?.length === 10){
  // this.ri = false;
  // this.refExists = false;
 

  const checkSum = this.registerForm.value.CustomerPan?.toUpperCase()+'N';
  const params = {
    "PanNumber": this.registerForm.controls.CustomerPan.value.toUpperCase(),
    "Mode":"N",
    "ApplicantName": this.registerForm.controls.CustomerName.value,
    "DOB": this.dob,
    'NRO': sessionStorage.getItem('NRO'),
  }
  this.loader.start();
  const path = 'DIY/PanSiteValidation';
  this.panLoader = true;
  // this.registerForm.controls['CustomerPan'].disable();
  this.panVerified = false;
  this._http.httpPost(path, params, checkSum).subscribe({
      next: (data:any)=>{
        this.loader.stop();
        // this.pansite = data;
        this.pansite = this.http.decryptUsingAES256(data.OutPut)
        this.panLoader = false;
        if(this.pansite && this.pansite.IsSuccess){
          this.panVerified = true;
          // setTimeout(() => {
          //   this.panvalidate = false;
          // }, 0);
          this.registerForm.controls['CustomerPan'].disable();
          this.registerForm.controls['CustomerName'].disable();
          this.registerForm.controls['userDOB'].disable();
          // this.registerForm.controls['NRO'].disable();
          // this.toastr.success(this.pansite.Success);
          this.firstName = this.pansite.cClientInfo.FirstName;
          this.middleName = this.pansite.cClientInfo.MiddleName;
          this.lastName = this.pansite.cClientInfo.LastName;
          if(this.firstName){
            this.panSiteName = this.firstName;
            this.firstName = this.firstName;
          }
          if(this.panSiteName && this.middleName){
            this.panSiteName =  this.panSiteName+' '+this.middleName;
            this.middleName = this.middleName;
          }else if(this.middleName){
            this.panSiteName = this.middleName;
            this.middleName = this.middleName;
          }
  
          if(this.panSiteName && this.lastName){
            this.panSiteName =  this.panSiteName+' '+this.lastName;
            this.lastName = this.lastName;
          }else if(this.lastName){
            this.panSiteName = this.lastName;
            this.lastName = this.lastName;
          }
          
          
          if(this.pansite.IsReferenceNumberExist){
            const element = document.getElementById('panModal') as HTMLElement;
            this.panModal = new Modal(element, {backdrop: 'static', keyboard: false});
            this.panModal.show();
            this.refExists = true;
            this.resumePan = this.registerForm.value.CustomerPan;
            return;
          }
          else{
            this.getkraStatus(this.registerForm.value.CustomerPan?.toUpperCase(),this.sessemail,this.mobile,this.dob,false)
            this.getCkycStatus(this.registerForm.value.CustomerPan?.toUpperCase(),this.sessemail,this.mobile,this.dob,);
            // this.genRefNumber();
          }
          // else if(this.pansite.ExistingAcResponse && this.pansite.ExistingAcResponse.ExistingDemat){
          //   if(this.pansite.ExistingAcResponse.RI){
          //     const element = document.getElementById('panModal') as HTMLElement;
          //     this.panModal = new Modal(element, {backdrop: 'static', keyboard: false});
          //     this.panModal.show();
          //     this.ri = true;
          //   }else {
          //     const element = document.getElementById('panModal') as HTMLElement;
          //     this.panModal = new Modal(element, {backdrop: 'static', keyboard: false});
          //     this.panModal.show();
          //     this.existingDemat = true;
          //     this.pansite.ExistingAcResponse.BankResponses.forEach((e:any)=>{
          //       if(e.CLIENT_SETTLEMENT_TYPE === "NRE-NONPIS"){
          //         this.nre_nonpis = false;
          //         this.nre_nonpisno = e.DEMAT_ACC_NO;
          //       }
          //       if(e.CLIENT_SETTLEMENT_TYPE === "NRE-PIS"){
          //         this.nre_pis = false;
          //         this.nre_pisno = e.DEMAT_ACC_NO;
          //       }
          //       if(e.CLIENT_SETTLEMENT_TYPE === "NRO-NONPIS"){
          //         this.nro_nonpis = false;
          //         this.nro_nonpisno = e.DEMAT_ACC_NO;
          //       }
          //       if(e.CLIENT_SETTLEMENT_TYPE === "NRO-PIS"){
          //         this.nro_pis = false;
          //         this.nro_pisno = e.DEMAT_ACC_NO;
          //       }
          //     })
          //   }
          // }
          // else{
          //   this.blockApp = false;
          // }
          // setTimeout(() => {
            
          // }, 500);
        }else{
          this.panvalidate = true;
          let error = this.pansite.Error ? this.pansite.Error : "";
            if(this.pansite.ErrorCode === "600"){
              const element = document.getElementById('TCSError') as HTMLElement;
              this.TCSError = new Modal(element, {backdrop: 'static', keyboard: false});
              this.TCSError.show();
            }else{
          //   if(this.pansite.ErrorCode === "2024"){
          //     this.registerForm.controls.userDOB.reset();
          //     this.registerForm.controls.userDOB.setValue("");
          //     this.datePicker.clearDate();
          //     const element = document.getElementById("dob");
          //     if (element && element.classList.contains("has-value")) {
          //       element.classList.remove("has-value");
          //     }
          //   }
          //   else if(this.pansite.ErrorCode === "2025"){
          //     this.registerForm.controls.userDOB.reset();
          //     this.registerForm.controls.CustomerName.reset();
          //     this.registerForm.controls.userDOB.setValue("");
          //     this.datePicker.clearDate();
          //     const element = document.getElementById("dob");
          //     if (element && element.classList.contains("has-value")) {
          //       element.classList.remove("has-value");
          //     }
          //   }
          //   else if(this.pansite.ErrorCode === "2023"){
          //     this.registerForm.controls.CustomerName.reset();
          //   }else{
          //     this.registerForm.controls['CustomerPan'].enable();
          //   }
            this.errorComp.ModalShow(error);
            }
            // this.toastr.error(error);
        }
      },error: e =>{
        this.panLoader = false;
        this.registerForm.controls['CustomerPan'].enable();
        // this.toastr.error(e.error.Message);
        this.errorComp.ModalShow(e.error.Message);
      }
  });
}
}  

genRefNumber(){
    let a:any = this.registerForm.controls.CustomerPan.value?.toUpperCase();
    let b:any = this.mobile;
    let c:any = this.sessemail;
    let d:any = this.panSiteName;
    const checkSum = a+b+c+d;
    let ccode = sessionStorage.getItem("code");
    // if(this.countryCode.TeleCode){
    //   ccode =  this.countryCode.TeleCode;
    // }else{
    //   ccode = this.countryCode;
    // }
    const params : any = {
      "Mode":"N",
      "PanNumber": a,
      "Mobile": b,
      "Email": c,
      "CustomerName": d,
      "FirstName": this.firstName,
      "MiddleName": this.middleName,
      "LastName": this.lastName,
      "CountryCode": ccode,
      "IsRM": this.rmAssist,
      "RMEmail": this.rmEmail ? this.rmEmail  : '',
      'NRO': sessionStorage.getItem('NRO'),
      'IsmartId': sessionStorage.getItem('IsmartId')?sessionStorage.getItem('IsmartId'):0,
  }
  if (this.rmAssist) {
     params['Source'] = this.search?.lgcode ? 'Y' : "N" ;
  }
  this.loader.start();
  const path = 'DIY/ReferenceNumberGeneration';
  this._http.httpPost(path, params, checkSum).subscribe({
    next: (data: any)=>{
      let value1= this.http.decryptUsingAES256(data.OutPut)
      this.loader.stop();
      if(value1.IsSuccess){
        sessionStorage.setItem('AxNo',value1.EncRefNumber);
        this._http.setRefNum(value1.EncRefNumber);
        this.overallStatus(value1.EncRefNumber);
        // this.overallStatus(value1.EncRefNumber);
        if(this.utmCampaign || this.utmMedium || this.utmSource){
          this.registerUTM(value1.EncRefNumber);
        }
        this._http.setRef(value1.ReferenceNumber);
        this.decref = value1.ReferenceNumber;
        this.Menu.refEvent(this.decref);
        // this.getPanInfo();
        // this.faceliveness.getImages();
        if(this.pansite.IsReferenceNumberExist){
        }
        if(value1.IsReferenceNumberExist){
          this.getDIYStatus(value1.EncRefNumber)
        }
        else{
          // this.registerStatus.emit(true);
          // this.getDIYStatus(value1.EncRefNumber)
          // let row = {
          //   "EncRefNumber": value1.EncRefNumber,
          //   "RefNumber": value1.ReferenceNumber,
          //   "PAN": this.registerForm.controls.CustomerPan.value?.toUpperCase(),
          //   "Email": this.registerForm.controls.CustomerEmail.value,
          //   "Mobile": this.registerForm.controls.Mobile.value
          // }
          // this.router.navigate(['/pan'], {state: row, replaceUrl: true });
          this.stageValidate();
        }
      }
    }, error: e =>{
      this.loader.stop();
      this.errorComp.ModalShow(e.error.Message);
      // this.toastr.error(e.error.Message)
    }
  });

}

registerUTM(ref:string){
  let ccode = sessionStorage.getItem("code");
  let rk_token = sessionStorage.getItem("rkToken");
  this.loader.start();
  let path = `DIY/RegisterUtm`
  const params = {
    "email": this.sessemail,
    "Mobile": this.mobile,
    "UtmSource": this.utmSource ? this.utmSource : "",
    "Campaign": this.utmCampaign ? this.utmCampaign : "",
    "Medium": this.utmMedium ? this.utmMedium : "",
    "CountryCode": ccode ? ccode : "",
    "ReferenceKey": rk_token ? rk_token : "",
    "IsResume": false,
    "ReferenceNumber": ref
  }
  const checksum = "";

  this._http.httpPost(path, params, checksum).subscribe({
    next: (data:any) => {
      this.loader.stop();
      let val = this.http.decryptUsingAES256(data.OutPut);
      if(val && val.IsSuccess){
      }
      console.log(val,"utm")
    },error : err => {
      // this.toastr.error(err.error.Message);
      this.errorComp.ModalShow(err.error.Message);
    }

  })
}

  getDIYStatus(ref: any){
    let url = 'DIY/DIYOverallStatus';
    const checkSum = ref;
    let params = {
      'ReferenceNumber': ref
    }
    this.loader.start();
    this._http.httpPost(url,params, checkSum).subscribe({
      next: (data:any)=>{
        this.loader.stop();
        let value = this.http.decryptUsingAES256(data.OutPut)
        if(value && value.IsSuccess){
          let item = value.overallLists;
          this.kraclient =value.KRA
          this.ckycclient = value.CKYC;
          this.selfieNeed = value.IsSelfieNeed;
          // this.registerForm.controls.NRO.setValue(value.NRO);
          // this.registerForm.controls['NRO'].disable();
          this._http.setStatus({
            PIOOCIType: value.PIOOCIType, 
            Stamp: value.StampRequired, 
            RMModule: value.IsRMJourney, 
            Mariner: value.Mariner, 
            ReStatus: value.ReStatus, 
            PIOOCI: value.PIOOCI, 
            Pan: value.PanNumber
          })
          // if(item[0].DIY === 'Y'){
          //   this.registerStatus.emit(true);
          // }
          // if (item.some((item:any) => item.DBO === 'D')) {
          //   this.resumeDrop();
          // } 
          // if (item[1].DIY !== 'Y' || item[1].DBO === 'R') {
          //   this.router.navigate(['/pan'], { replaceUrl: true });
          //   if(item[1].DBO === 'R'){
          //     this.remarks = item[1].Remarks;
              
          //     this.toastr.error(item[1].Remarks)
          //   }
          // }
          // else if(item[2].DIY !== 'Y' || item[2].DBO === 'R'){
          //   this.router.navigate(['/passport'], { replaceUrl: true });
          //   if(item[2].DBO === 'R'){
          //     this.remarks = item[2].Remarks;
              
          //     this.toastr.error(item[2].Remarks)
          //   }
          // }
          // else if(value.ReStatus === 'FN' && item[3].DIY !== 'Y' || item[3].DBO === 'R'){
          //   this.router.navigate(['/oci-pio'], { replaceUrl: true });
          //   if(item[3].DBO === 'R'){
          //     this.remarks = item[3].Remarks;
              
          //     this.toastr.error(item[3].Remarks)
          //   }
          // }
          // else if(!value.Mariner && item[4].DIY !== 'Y' || item[4].DBO === 'R'){
          //   this.router.navigate(['/foreign-address'], { replaceUrl: true });
          //   if(item[4].DBO === 'R'){
          //     this.remarks = item[4].Remarks;
              
          //     this.toastr.error(item[4].Remarks)
          //   }
          // }
          // else if(item[5].DIY !== 'Y' || item[5].DBO === 'R'){
          //   this.router.navigate(['/address'], { replaceUrl: true });
          //   if(item[5].DBO === 'R'){
          //     this.remarks = item[5].Remarks;
              
          //     this.toastr.error(item[5].Remarks)
          //   }
          // }
          // else if(value.ReStatus !== 'FN' && item[6].DIY !== 'Y' || item[6].DBO === 'R'){
          //   this.router.navigate(['/visa'], { replaceUrl: true });
          //   if(item[6].DBO === 'R'){
          //     this.remarks = item[6].Remarks;
              
          //     this.toastr.error(item[6].Remarks)
          //   }
          // } 
          // else if(item[10].DIY !== 'Y' || item[10].DBO === 'R'){
          //   this.router.navigate(['/segments'], { replaceUrl: true });
          //   if(item[10].DBO === 'R'){
          //     this.remarks = item[10].Remarks;
              
          //     this.toastr.error(item[10].Remarks)
          //   }
          // }
          // else if(item[9].DIY !== 'Y' || item[9].DBO === 'R'){
          //   this.router.navigate(['/bank'], { replaceUrl: true });
          //   if(item[9].DBO === 'R'){
          //     this.remarks = item[9].Remarks;
              
          //     this.toastr.error(item[9].Remarks)
          //   }
          // }
          // else if(item[8].DIY !== 'Y' || item[8].DBO === 'R'){
          //   this.router.navigate(['/ridetails'], { replaceUrl: true });
          //   if(item[8].DBO === 'R'){
          //     this.remarks = item[8].Remarks;
              
          //     this.toastr.error(item[8].Remarks)
          //   }
          // }
          // else if(item[7].DIY !== 'Y' || item[7].DBO === 'R'){
          //   this.router.navigate(['/fatca'], { replaceUrl: true });
          //   if(item[7].DBO === 'R'){
          //     this.remarks = item[7].Remarks;
              
          //     this.toastr.error(item[7].Remarks)
          //   }
          // }
          // else if(item[11].DIY !== 'Y' || item[11].DBO === 'R'){
          //   this.router.navigate(['/nominee'], { replaceUrl: true });
          //   if(item[11].DBO === 'R'){
          //     this.remarks = item[11].Remarks;
              
          //     this.toastr.error(item[11].Remarks)
          //   }
          // }
          // else if(item[12].DIY !== 'Y' || item[12].DBO === 'R'){
          //   this.router.navigate(['/photo'], { replaceUrl: true });
          //   if(item[12].DBO === 'R'){
          //     this.remarks = item[12].Remarks;
              
          //     this.toastr.error(item[12].Remarks)
          //   }
          // }
          // else if(item[13].DIY !== 'Y' || item[13].DBO === 'R'){
          //   this.router.navigate(['/aof'], { replaceUrl: true });
          //   if(item[13].DBO === 'R'){
          //     this.remarks = item[13].Remarks;
              
          //     this.toastr.error(item[13].Remarks)
          //   }
          // }
          // else{
          // }
        }
      },
      error: _error=>{
        this.loader.stop();
      }
    });
  }
  
onPanChange(event: any) {
  const inputText = event.target.value;
  const sanitizedText = inputText.replace(/[^a-zA-Z0-9]/g, '');

  if (inputText !== sanitizedText) {
    event.target.value = sanitizedText;
  }
}
  overallStatus(ref:any){
    let url = 'DIY/DIYOverallStatus';
    this.loader.start();
    let checkSum =ref;    
    let params = {
      'ReferenceNumber':ref,
    }
    this._http.httpPost(url,params, checkSum).subscribe({
      next: (data:any) => {
        this.loader.stop();
        let overallVal = this.http.decryptUsingAES256(data.OutPut);
        if(overallVal && overallVal.IsSuccess){
          this.selfieNeed = overallVal.IsSelfieNeed;
          this.kraclient = overallVal.KRA;
          this.ckycclient = overallVal.CKYC;
           let item = overallVal.overallLists;
      // if (item[1].DIY !== 'Y' || item[1].DBO === 'R') {
              
                if(item[1].DBO === 'R'){
                  setTimeout(() => {
                    this.panvalidate =true;
                    this.panreject = true;
                    // this.remarks = item[1].Remarks;
                  }, 1000);
                }
              // }
          // this.registerForm.controls.NRO.setValue(overallVal.NRO);
          // this.registerForm.controls['NRO'].disable();
        }
      },
      error: _error=>{
        this.loader.stop();
        // this.toastr.error(_error.error.Message)
        this.errorComp.ModalShow(_error.error.Message);
      }
    })
  }
  getImageStatus(event:boolean){
    this.isSelfie = event;
  }

  checkCode() {
    let c = '';
    if (this.countryCode && this.countryCode.TeleCode) {
      c = this.countryCode.TeleCode;
    } else {
      c = this.countryCode;
    }
  
    let code = this.countryList.filter((e: any) => {
      return e.TeleCode === c;
    });
  
    if (!code || code.length === 0) {
      this.countryCodeError = true;
    } else {
      this.countryCodeError = false;
    }
  }

  telcode(event: any){
    if(event.length > 3){
      event = event.substring(0, event.length-1);
    }
    this.countryCode = event;
  }

  selectCodeEvent(event: string){

  }

  // numericOnly(event:any){
  //   const pattern = new RegExp('^[0-9\b]+$');
  //   const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  //   if (!pattern.test(key) && event.charCode !== 0) {
  //       event.preventDefault();
  //       return;
  //   }
  // }

  restrictEnter(args: any) {
    if (args.key === "Enter" && args.keyCode == 13)
      args.preventDefault();
  }

  getCountryName(){
    let c = parseInt(this.country)
    let name = this.countryList.filter((e:any)=>{
      return e.Id === c;
    })
    this.countryName = name[0].Name;
  }

  getPanInfo(){
    
    let url = "DIY/DIYGetPanInfo";
    let checkSum = this.erefNo;    
    let params = {
      "ReferenceNumber": this.erefNo
    }
    this.loader.start();
    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data:any)=>{
        this.loader.stop();
        let value = this.http.decryptUsingAES256(data.OutPut);
        if(value.IsSuccess) {
          this.ocrSuccess = true;
          this.panvalidate = false;
        }
        if(value){
        if(value.FirstName){
          this.panSiteName = value.FirstName;
          this.firstName = value.FirstName;
        }
        if(this.panSiteName && value.MiddleName){
          this.panSiteName =  this.panSiteName+' '+value.MiddleName;
          this.middleName = value.MiddleName;
        }else if(value.MiddleName){
          this.panSiteName = value.MiddleName;
          this.middleName = value.MiddleName;
        }

        if(this.panSiteName && value.LastName){
          this.panSiteName =  this.panSiteName+' '+value.LastName;
          this.lastName = value.LastName;
        }else if(value.LastName){
          this.panSiteName = value.LastName;
          this.lastName = value.LastName;
        }
        if(this.panSiteName){
          this.registerForm.controls.CustomerName.setValue(this.panSiteName);
          this.registerForm.controls['CustomerName'].disable();
        }
        if(value.MobCountrycode){
          this.countryCode = value.MobCountrycode;
        }

      //   if(value.AccStatementFrequency){
      //     this.accountStatement = value.AccStatementFrequency;
      //   }
      //   if(value.PoliticalPerson === true){
      //     this.politicallyExposed = "PE";
      //   }else{
      //     this.politicallyExposed = "RPE";
      //   }
      //   if(value.GST === false){
      //     this.gstNumber = "GN"
      //   }else{
      //     this.gstNumber = "GY"
      //   }
      //  if(value.GST && this.gstNumber === "GY"){
      //   this.gst = value.GSTNumber;
      //   this.state = value.GSTState;
      //  }
          if(value.MobileLinkedAadhar){
            this.aadhar('yes');
          }else{
            this.aadhar('no');
          }

          if(value.Marine_Seafarer){
            this.marineStatus = 'Y';
            this.countryList = this.countryMaster.filter((e:any)=>{
              return e.Name;
            })
            this._http.setStatus({
              PIOOCIType: this.getStatusData.PIOOCIType, 
              Stamp: this.getStatusData.Stamp, 
              RMModule: this.getStatusData.RMModule, 
              Mariner: true, 
              ReStatus: this.getStatusData.ReStatus, 
              PIOOCI: this.getStatusData.PIOOCI, 
              Pan: this.getStatusData.Pan
            })
          }else{
            this.marineStatus = 'N';
            this._http.setStatus({
              PIOOCIType: this.getStatusData.PIOOCIType, 
              Stamp: this.getStatusData.Stamp, 
              RMModule: this.getStatusData.RMModule, 
              Mariner: false, 
              ReStatus: this.getStatusData.ReStatus, 
              PIOOCI: this.getStatusData.PIOOCI, 
              Pan: this.getStatusData.Pan
            })
          }
          
          this.resStatus = value.AppStatus;
          if(this.resStatus === 'FN'){
            this.foreignStatus = value.PIOOCI;
          }
          if(value.PanNumber){
            // setTimeout(() => {
            //   this.panvalidate = false;
            // }, 0);
            this.registerForm.controls['CustomerPan'].disable();
            this.registerForm.controls.CustomerPan.setValue(value.PanNumber);
            const encryptedPan:string = this.http.encryptUsingAES256(value.PanNumber);
            sessionStorage.setItem("pan",encryptedPan);
            // this.registerForm.controls.NRO.setValue(value.NRO);
            // this.registerForm.controls['NRO'].disable();
          }
          this.nriEmail = value.Email;
          this.nriMobile = value.Mobile;
          if(value.DOB){
            this.relationName = value.FatherOrSpouseName;
            this.kraStatus = value.KRAClient;
            this.ckycStatus = value.CKYC;
            this.panURL = value.PanImage;
            this.country = value.CountryId;
            let a = value.DOB.split(' ');
            let d = a[0].split('/');
            this.userDOB = { date: { year: d[2], month: parseInt(d[1]), day: parseInt(d[0]) } };
            this.registerForm.controls.userDOB.setValue(this.userDOB);
            // this.registerForm.patchValue({
            //   userDOB:this.userDOB
            // })
            this.dob = a[0];
            this.registerForm.controls['userDOB'].disable();
          }
          this.countryName = value.Country;
        }
        
        // if(value && value.IsSuccess){
        //   setTimeout(() => {
        //     this.getkraStatus(value.PanNumber,value.Email,value.Mobile,this.dob,true);
        //     this.getCkycStatus(value.PanNumber);
        //   }, 500);
          
        // }
      },error: _error=>{
        this.loader.stop();
        this.errorComp.ModalShow(_error.error.Message);
        // this.toastr.error(_error.error.Message);
      }
    })
  }

  getkraStatus(pan:any,email:string,mobile:string,dob:string,resume:boolean){
    this.loader.start();
    const checkSum = pan+email;
    const params = {
      "PanNumber": pan ? pan : "",
      "Email": email,
      "Mobile": mobile,
      "Mode":"N"
    }
    const path = 'DIY/VerifyKRAClientStatus';
    this._http.httpPost(path, params, checkSum).subscribe({
      next: (data:any) => {
        this.loader.stop();
        let kraValue = this.http.decryptUsingAES256(data.OutPut);
        if(kraValue && kraValue.IsSuccess) {
          this.ErrorCode = kraValue.ErrorCode;
          if(!resume){
            this.kraValidationUpdate(email,mobile,pan,dob,resume);
          } else {
            this.panvalidate = false;
            this.overallStatus(sessionStorage.getItem('AxNo'));
          }
        }
        if(kraValue.IsKRAVerified === "Y"){
          this.isKRA = 'Registered'; 
          this.kraStatus = 'Y';
        }else{
          this.isKRA = 'NON KRA'; 
          this.kraStatus = 'N';
        }
      },
      error: _error  =>{
        this.loader.stop();
      }
    })
  
  }

  kraValidationUpdate(Email:string,Mob:string,Pan:string,Dob:string,resume:boolean) {
    this.loader.start();
    let eml = Email;
    let mob = Mob;
    let params = {
      "email": eml,
      "Mobile": mob,
      "PanNumber": Pan,
      "ErrorCode":this.ErrorCode,
      "DOB": Dob,
      "Mode":"W",
      "IsDiy":true,
      "CustomerName": this.panSiteName,
      "LastName": this.lastName,
      "CountryCode": resume ? this.countryCode : this.sessCode,
    }
    const path = `DIY/KRAClientValidationupdate`;
    const checkSum = Pan;
    this._http.httpPost(path,params,checkSum).subscribe({
      next: (data:any) => {
        this.loader.stop();
        if(data && data.OutPut) {
          let decryptedResponse = this.http.decryptUsingAES256(data.OutPut);
          if(decryptedResponse.IsSuccess){
              this.panvalidate = false;
              this.appStatus = decryptedResponse.KRAExistingClientInfo['APP_RES_STATUS'];
              console.log(this.appStatus);
              let riTonri: boolean = false;
              if(sessionStorage.getItem('riToNri')){
                riTonri = true;
              }
              if(this.appStatus && this.appStatus.toUpperCase() === "R" && !this.refExists && !riTonri) {
                const element = document.getElementById('appstatus') as HTMLElement;
                this.statusModal = new Modal(element, {backdrop: 'static', keyboard: false});
                this.statusModal.show();
              } else {
                this.genRefNumber();
              }
          } else {
            this.loader.stop();
            this.panvalidate = false;
            this.genRefNumber();
            if (sessionStorage.getItem('AxNo')) {
              this.overallStatus(sessionStorage.getItem('AxNo'));
            }
            // let host = location.host;
            // if (host === 'localhost:4200' || host === '15.206.52.226:8040') {
            //   this.errorComp.ModalShow('Unable to process from server, please wait for sometime');
            // } else {
            //   this.errorComp.ModalShow('Unable to process from server, please wait for sometime' , true , '/register', true);
            // }
          }
        }
      },error : e => {
        this.loader.stop();
        // let host = location.host;
        // if (host === 'localhost:4200' || host === '15.206.52.226:8040') {
        //   this.errorComp.ModalShow(e.error.Message);
        // } else {
        //   this.errorComp.ModalShow(e.error.Message , true , '/register' , true);
        // }
        this.panvalidate = false;
        if (sessionStorage.getItem('AxNo')) {
          this.overallStatus(sessionStorage.getItem('AxNo'));
        }
      }
    })
  }

  bindOcr(event:any) {
    setTimeout(() => {
      console.log(event,"pan OCR Datas");
    let ocrDatas = event.data.BindingdataFront;
    this.ocrSuccess = event.success;
    if (this.dob) {
      this.dob = "";
      this.registerForm.patchValue({
        userDOB: null,
        CustomerName: "",
        CustomerPan: ""
      })
      this.datePicker.clearDate();
    }
    if (ocrDatas && this.ocrSuccess) {
      this.registerForm.patchValue({
        CustomerName: ocrDatas.NameOnCard ? ocrDatas.NameOnCard.trim() : '',
        CustomerPan : ocrDatas.IdNumber ? ocrDatas.IdNumber.trim() : '',
      })
      // this.registerForm.controls['CustomerPan'].setValue(ocrDatas.IdNumber);
      // this.registerForm.controls['CustomerName'].setValue(ocrDatas.NameOnCard);


      if(ocrDatas.DateOfBirth){
        let a = ocrDatas.DateOfBirth.split('-');
        this.userDOB = { date: { year: a[0], month: parseInt(a[1]), day: parseInt(a[2]) } };
        this.registerForm.controls.userDOB.setValue(this.userDOB);
        this.dob = `${a[2]}/${a[1]}/${a[0]}`;
        const ele = document.getElementById("dob");
        if (ele) ele?.setAttribute('value', this.dob);
        this.registerForm.patchValue({
          userDOB : this.userDOB
        })
      }
      this.registerForm = this.formBuilder.group({
        CustomerName: [ocrDatas.NameOnCard.trim(), [Validators.required]],
        CustomerPan: [ocrDatas.IdNumber.trim(), [Validators.required , ValidationService.panValidator]],
        userDOB: [this.userDOB, [Validators.required]],
        // NRO: ['', [Validators.required]],
      })
      
    } else {
      this.registerForm.enable();
      // this.toastr.error('Error In File upload');
    }
    // let flags = ["CustomerName","CustomerPan","userDOB"];
    let flags = Object.keys(this.registerForm.controls);
    flags.forEach(flag => {
      this.registerForm.get(flag)?.valid ? this.registerForm.get(flag)?.disable() : this.registerForm.get(flag)?.enable();
    })
    }, 1000);
    
  }

  reDirection() {
    // this.statusModal.hide();
    // sessionStorage.setItem("riToNri", JSON.stringify(true));
    sessionStorage.clear();
    location.reload();
    // let href = "https://predigikyc.sbicapsec.com/NEWDIY/register";
    // location.replace(href);
  }

  getCkycStatus(panNumber: any,email:any,mob:any,dob:any){

    const checkSum = this.pan+'N';
    const params = {
      "PanNumber": panNumber,
      "DOB":dob,
      "Email":email,
      "Mobile":mob
    }
    const path = 'DIY/CKYCTrackWizzSearchV1';
    this._http.httpPost(path, params, checkSum).subscribe({
      next: (data:any)=>{
        let ckycData = this.http.decryptUsingAES256(data.OutPut)
        // if(ckycData.CKYC === "Y"){
        //   this.isCKYC = 'Registered';
        //   this.ckycStatus = 'Y';
        // }else{
        //   this.isCKYC = 'Non CKYC'
        //   this.ckycStatus = 'N'
        // }
      },
      error: _error  =>{

      }
    })
  }

  onDateChanged(event: IMyDateModel){
    this.dob = event.formatted;
    this.dobError = false;
    const elem = document.getElementById("dob") as HTMLInputElement;
    elem.value = event.formatted;
  }

  // onDateInputChanged(event: any) {
  //   const inputDate = event.formatted;
  //   this.userDOB = inputDate;
  //   this.setDateInCalendar();
  // }
  
  // onDateChanged(event: any) {
  //   const selectedDate = event.date;
  //   if (selectedDate) {
  //     const day = selectedDate.day;
  //     const month = selectedDate.month;
  //     if(month){
  //       if(month > 12 || month > "12"){
  //         this.toastr.error("Select a Valid Month");
  //         return;
  //       }
  //     }
  //     let y = (new Date().getFullYear()-18);
  //     const year = selectedDate.year;
  //     if(year){
  //       if(year > y){
  //         this.toastr.error("Enter a Valid Year");
  //         return;
  //       }
  //     }
  //     this.userDOB = `${day}/${month}/${year}`;
  //   }
  // }

  onlyNumberKey(event: any) {
    const pattern = new RegExp('^[0-9\b]+$');
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!pattern.test(key) && event.charCode !== 0) {
              event.preventDefault();
              return;
    }
  }
  pepChange(value:boolean){
    this.pep = value;
}

  stageValidate(){
    if(!this.pep){
      this.errorComp.ModalShow("In case of “Politically exposed person”(PEP), or related to a PEP, please submit the application in physical mode.");
      // this.toastr.error("Please Select I am not politically-exposed (PEP) or related to a PEP");
      return;
    }
    if(this.selfieNeed && !this.isSelfie){
      this.errorComp.ModalShow("Please Upload your selfie image");
      // this.toastr.error("Please Upload your selfie image");
      return;
    }
    const invalidControl = this.el.nativeElement.querySelector('.ng-invalid');
    if (invalidControl) {
      invalidControl.focus();
    }
    // if(this.countryCode === "" || this.countryCode === null || this.countryCode === undefined){
    //   this.toastr.error("Please Provide Country Code");
    //   return;
    // }
    // if (this.gstNumber === 'GY') {
    //   if (this.gst === "" || this.gst === undefined || this.gst === null) {
    //     this.toastr.error("Please Enter the GST Number");
    //     return;
    //   }
    //   if (this.state === "" || this.state === undefined || this.state === null) {
    //     this.toastr.error("Please Enter the State");
    //     return;
    //   }
    // }
    if(!this.dob){
      this.dobError = true;
      return;
    }
    // else if(!this.relationName || this.relationName.length < 3){
    //   this.relationNameEmpty = true
    // }
    // else if(!this.country){
    //   this.countryEmpty = true
    // }
    else if(!this.panUpdt){
      this.errorComp.ModalShow("Please upload pan card image");
      // this.toastr.error('Please upload pan card image');
      return;
    }
    // else if(!this.politicallyExposed){
    //   this.toastr.error("Please select Whether you are PEP")
    // }
    // else if(!this.accountStatement){
    //   this.toastr.error("Please select Account statement frequency")
    // }
    
    // else if(!this.countryName){
    //   this.toastr.error("Please select the country")
    // }
    
    else{
      const checkSum = this.dob+this.erefNo;
      this.loader.start();
      let params = {
        // "AppStatus": this.resStatus,
        // "CKYC": this.ckycStatus,
        // "CountryId": this.country,
        // "Country": this.countryName,
        "DOB": this.dob,
        // "Email": this.nriEmail,
        // "FatherOrSpouse": 'F',
        // "FatherOrSpouseName": this.relationName,
        "FirstName": this.firstName,
        // "KRAClient": this.kraStatus,
        "LastName": this.lastName,
        // "Marine_Seafarer":this.marineStatus === 'Y' ? true : false,
        "MiddleName": this.middleName,
        // "Mobile": this.nriMobile,
        "PanNumber": this.registerForm.controls.CustomerPan.value,
        // "POI_OCI": this.resStatus === 'FN' ? true : false,
        "POIOCI": this.foreignStatus,
        "ReferenceNumber": this.erefNo,
        "MobileLinkedAadhar": this.aadharStatus,
        "IsSelfieTaken": this.selfieNeed
        // "PoliticalPerson":this.politicallyExposed === 'PE' ? true :false,
        // "GST":this.gstNumber === 'GN' ? false : true,
        // "AccStatementFrequency":this.accountStatement,
        // "GSTNumber":this.gst ? this.gst : "",
        // "GSTState":this.state ? this.state : ""
        // "Title": this.title
      }

      let url = "DIY/DIYUpdatePanInfo";
      this._http.httpPost(url, params, checkSum).subscribe({
        next: (data:any)=>{
        let updatePanValue = this.http.decryptUsingAES256(data.OutPut)
        this.loader.stop();
        if(updatePanValue && updatePanValue.IsSuccess){
          // this.toastr.success(updatePanValue.Success);
        this._http.setStatus({
          // Mariner: this.marineStatus === 'Y' ? true : false,
          // ReStatus: this.resStatus, 
          // PIOOCI: this.resStatus === 'FN' ? true : false,
          // PIOOCIType:this.foreignStatus,
          // Stamp: this.getStatusData.StampRequired, 
          // RMModule: this.getStatusData.IsRMJourney, 
          Pan: this.getStatusData.PanNumber
        })
        if(sessionStorage.getItem('NRO')==='N'){
          this.router.navigate(['/passport'], { replaceUrl: true });
        }else{
         this.router.navigate(['/photo'], { replaceUrl: true });
        }
      }else{
        this.errorComp.ModalShow(updatePanValue.Error);
        // this.toastr.error(updatePanValue.Error);
      }
    },
      error: error=>{
        this.loader.stop();
        const panDetails = error.error.ModelState;
        for (const key in panDetails) {
          if (panDetails.hasOwnProperty(key)) {
            const errorMessages = panDetails[key];
            if (Array.isArray(errorMessages) && errorMessages.length > 0) {
              this.errorComp.ModalShow(errorMessages[0]);
              // this.toastr.error(errorMessages[0]);
              return; 
            }
          }
        }
        // this.toastr.error(error.error.Message)
      }
    });
  }
  }

  
  updateEmailMobile(){
    const checkSum = this.nriEmail+this.erefNo;
    const params = {
      "Mobile": this.nriMobile,
      "Email": this.nriEmail,
      "IsEmail":true,
      "ReferenceNumber": this.erefNo,
      "Validate":checkSum,
    }

    const path = 'DIY/UpdateEmailMobile';
    this._http.httpPost(path, params, checkSum).subscribe({
      next: (data:any)=>{
      let updateEmailMobValue = this.http.decryptUsingAES256(data.OutPut)
        this.loader.stop();
      if(updateEmailMobValue.IsSuccess){
        // this.toastr.success(updateEmailMobValue.Success);
        this.disableEmailEdit = false;
      }
      else{
        this.errorComp.ModalShow("Error Uploading new Data");
        // this.toastr.error("Error Uploading new Data")
      }
      }
    })
  }
  updateMobile(){
    const checkSum = this.nriEmail+this.erefNo;
    let ccode = '';
      if(this.countryCode.TeleCode){
        ccode =  this.countryCode.TeleCode;
      }else{
        ccode = this.countryCode;
      }
    const params = {
      "Mobile": this.nriMobile,
      "Email": this.nriEmail,
      "IsMobile":true,
      "ReferenceNumber": this.erefNo,
      "Validate":checkSum,
      "CountryCode": ccode
    }
    this.loader.start();

    const path = 'DIY/UpdateEmailMobile';
    this._http.httpPost(path, params, checkSum).subscribe({
      next: (data:any)=>{
      let mobileVal = this.http.decryptUsingAES256(data.OutPut)
      if(mobileVal.IsSuccess){
        this.loader.stop();
        // this.toastr.success(mobileVal.Success);
        this.mobValidatebtn = false;
        this.disableMobileEdit = false;
        this.stageValidated = false;
        this.disableCountrycode = true;
      }
      else{
        this.loader.stop();
        this.errorComp.ModalShow(mobileVal.Error || "Error Uploading new Data");
        // this.toastr.error(mobileVal.Error || "Error Uploading new Data")
        this.mobValidatebtn = true;
        this.cancelmobotp()
      }
      }
    })
  }

  mfStatus(){
   if(this.marineStatus === 'Y'){
    this.resStatus = "N"
    this.countryName = "India";
      this.countryList = this.countryMaster.filter((e:any)=>{
        return e.Name;
      })
      let indiaObject = this.countryList.findIndex((country:any) => country.Name === 'India');
      this.country = this.countryList[indiaObject].Id;
   }else{
    this.country = "";
    this.countryList = this.countryMaster.filter((e: any) => {
      return e.Name !== "India";
    });
   }
  }

  nationality(){
    if(this.resStatus === 'FN'){
      this.country = "";
      this.foreignStatus = 'P';
      this.marineStatus = 'N';
      this.countryList = this.countryMaster.filter((e: any) => {
        return e.Name !== "India";
      })
    }else{
      this.foreignStatus = '';
      
      
    }
  }



  spaceValidation(event:any){
    const input = event.target.value;
    event.target.value = input.replace(/^\s+|\s+$|\s+(?=\s)/g, "");
    this.relationName = event.target.value;
  }

  onInputChange(event: any) {
    const pattern = /^[a-zA-Z \b]+$/;
    const inputText = event.target.value;
  
    if (!pattern.test(inputText)) {
      event.target.value = inputText.replace(new RegExp(`[^a-zA-Z \b]+`, 'g'), '');
    }
  }

  numericOnly(event: any) {
    const pattern = /^[0-9\b]+$/;
    const inputText = event.target.value;
  
    if (!pattern.test(inputText)) {
      event.target.value = inputText.replace(new RegExp(`[^0-9]+`, 'g'), '');
    }
  }

  imageURL(event: any){
    if(event.url){
      this.panUpdt = true;
      this.panImgempty = false;
      this.ocrSuccess = true;
    }
    if(!event.url){
      this.panUpdt = false;
      this.ocrSuccess = false;
    }
  }
  mobileEdit(){
    if (!this.disableMobileEdit) {
    this.disableMobileEdit = true;
    this.oldMobile = this.nriMobile;
    this.oldCountrycode = this.countryCode;
    this.countryCode = "";
    this.disableCountrycode = false;
    this.nriMobile = '';
    this.mobValidatebtn = true;
    this.mobCancel = true;
    this.stageValidated = true;
    const mobElement = document.getElementById('mobile');
    if (mobElement) {
      mobElement.removeAttribute('disabled');
    }
  }
  }
  emailEdit() {
    if (!this.disableEmailEdit) {
    this.disableEmailEdit = true;
    this.oldNriEmail = this.nriEmail;
    this.nriEmail = '';
    this.emailValidatebtn = true;
    this.emailCancel = true;
    this.stageValidated = true;
    const emailElement = document.getElementById('email');
    if (emailElement) {
      emailElement.removeAttribute('disabled');
    }
  }
  }
  cancelotp(){
    this.disableEmailEdit = false;
    this.nriEmail = this.oldNriEmail;
    this.emailValidatebtn = false;
    this.emailCancel = false;
    this.otptriggerEmail = false;
    this.stageValidated = false;
    const emailElement = document.getElementById('email');
    if (emailElement) {
      emailElement.setAttribute('disabled', 'true');
    }
  }
  cancelmobotp(){
    this.disableMobileEdit = false;
    this.nriMobile = this.oldMobile;
    this.countryCode = this.oldCountrycode;
    this.mobValidatebtn = false;
    this.mobCancel = false;
    this.otptriggermob = false;
    this.stageValidated = false;
    this.disableCountrycode = true;
    const mobElement = document.getElementById('mobile');
    if (mobElement) {
      mobElement.setAttribute('disabled', 'true');
    }
  }
  
  // emailOnly(event:any){
  //   const pattern = new RegExp('^[-a-zA-Z0-9._@\b]+$');
  //       const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  //       if (!pattern.test(key) && event.charCode !== 0) {
  //           event.preventDefault();
  //           return;
  //     }
  // }

  emailOnly(event: any) {
    const pattern = /^[-a-zA-Z0-9._@]+$/;
    const inputText = event.target.value;
  
    if (!pattern.test(inputText)) {
      event.target.value = inputText.replace(new RegExp(`[^-a-zA-Z0-9._@]+`, 'g'), '');
    }
  }

  togglePasswordVisibility() {
    this.showOTP = !this.showOTP;
    const otpInput = document.getElementById('emotp') as HTMLInputElement;
    otpInput.type = this.showOTP ? 'text' : 'password';
  }
  reSendOTPStatus(event: any){
    this.reSendOTP = event;
  }
  // onEmailChange(newEmail: string) {
  //   this.editedEmail = newEmail;
  //   console.log(this.editedEmail);
  //   console.log(this.nriEmail);
  // }
  genOTP(){
    if(this.nriEmail == ""){
      this.errorComp.ModalShow("Please enter the Email address");
      // this.toastr.error("Please enter the Email address");
      return;
    }else{
      const emailElement = document.getElementById('email');
      if (emailElement) {
        emailElement.setAttribute('disabled', 'true');
      }
    this.emailCancel = false;
    this.emailOTP = "";
      let error = 0;
      this.rmfullemail = this.rmEmail + this.rmDomain;
      if(error === 0){
        let checkSum = '';
        if(this.rmAssist){
          checkSum = this.nriEmail + this.rmfullemail;
        }else{
          checkSum = this.nriEmail + this.nriEmail;
        }
       
        const params = {
          "CustomerEmail": this.nriEmail,
          "IsRMJourney":this.rmAssist,
          "RMEmail": "",
          "Email": this.rmAssist ? this.rmfullemail : this.nriEmail,
          "Mobile": this.nriMobile,
          "Update":true,
          "IsEmail":true,
          "IsMobile":false,
        }
        this.loader.start();
        this.reSendOTP = false;
        const path = 'DIY/EmailOtp';
        this._http.httpPost(path, params, checkSum).subscribe({
          next: (data:any)=>{
            let emailValue = this.http.decryptUsingAES256(data.OutPut)
            this.loader.stop();
            if(emailValue && emailValue.IsSuccess){
              // this.toastr.success("OTP Sent Successfully");
              this.otptriggerEmail = true;
              this.emailValidatebtn = false;
             }else{
              if(emailValue && emailValue.Error){
                this.otptriggerEmail = false;
                this.emailValidatebtn = true;
                this.errorComp.ModalShow(emailValue.Error);
                // this.toastr.error(emailValue.Error);
                const emailElement = document.getElementById('email');
                  if (emailElement) {
                    emailElement.removeAttribute('disabled');
                  }
              }else{
                this.errorComp.ModalShow("Please try again later.");
                // this.toastr.error("Please try again later.")
              }
            }
          }, error: e =>{
            this.loader.stop();

            const panDetails = e.error.ModelState;
            for (const key in panDetails) {
              if (panDetails.hasOwnProperty(key)) {
                const errorMessages = panDetails[key];
                if (Array.isArray(errorMessages) && errorMessages.length > 0) {
                  this.errorComp.ModalShow(errorMessages[0]);
                  // this.toastr.error(errorMessages[0]);
                  this.emailCancel = true;
                  const emailElement = document.getElementById('email');
                  if (emailElement) {
                    emailElement.removeAttribute('disabled');
                  }
                  return;
                }
              }
            }
          }
        }
  )}
  }}
genOTP1(){
  const isValid = this.validateMobileNumber();
  if(!isValid){
    return;
  }
  if(this.nriMobile == ""){
    this.errorComp.ModalShow("Please enter the Mobile Number");
    // this.toastr.error("Please enter the Mobile Number");
    return;
  }
  if(this.countryCode == ""){
    this.errorComp.ModalShow("Please enter the country code");
    // this.toastr.error("Please enter the country code");
    return;
  }
  if(this.nriMobile && this.nriMobile.length < 7){
    this.errorComp.ModalShow("Please Provide Valid Mobile Number");
    // this.toastr.error("Please Provide Valid Mobile Number");
    return;
  }
  const mobElement = document.getElementById('mobile');
    if (mobElement) {
      mobElement.setAttribute('disabled', 'true');
    }
  this.disableCountrycode = true;
  this.mobCancel = false;
  this.updateMobile();
}
validateOTP(){
  console.log('emailOTP:', this.emailOTP);
  if(this.emailOTP == ""){
    this.errorComp.ModalShow("Please enter the OTP");
    // this.toastr.error("Please enter the OTP");
    return;
  }
  this.stageValidated = false;
  let checkSum = '';
  if(this.rmAssist){
    checkSum = this.rmfullemail + this.emailOTP;
  }else{
    checkSum = this.nriEmail + this.emailOTP;
  }
  const params = {
    "Email": this.rmAssist ? this.rmfullemail : this.nriEmail,
    "OTP": this.emailOTP,
  }
  this.loader.start();
  const path = 'DIY/ValidateOTP';
  this._http.httpPost(path, params, checkSum).subscribe({
    next: (data:any)=>{
      this.loader.stop();
      let validateValue = this.http.decryptUsingAES256(data.OutPut)
      if(validateValue.IsSuccess){
        // this.toastr.success("OTP Validated Successfully");
        this.updateEmailMobile();
        this.otptriggerEmail = false;
      }else{
        this.errorComp.ModalShow(validateValue.Message);
        // this.toastr.error(validateValue.Message);
        this.otpError = true;
      }
    }, error: _error =>{
      this.loader.stop();
      this.otpError = true;
      this.errorComp.ModalShow(_error.error.Message);
      // this.toastr.error(_error.error.Message)

    }
  });

}

validateMobOTP(){
  if(this.emailOTP == ""){
    this.errorComp.ModalShow("Please enter the OTP");
    // this.toastr.error("Please enter the OTP");
    return;
  }
  this.stageValidated = false;
  let checkSum = '';
  if(this.rmAssist){
    checkSum = this.rmfullemail + this.emailOTP;
  }else{
    checkSum = this.nriEmail + this.emailOTP;
  }
  const params = {
    "Email": this.rmAssist ? this.rmfullemail : this.nriEmail,
    "OTP": this.emailOTP,
  }
  this.loader.start();
  const path = 'DIY/ValidateOTP';
  this._http.httpPost(path, params, checkSum).subscribe({
    next: (data:any)=>{
      this.loader.stop();
      let MobOTP = this.http.decryptUsingAES256(data.OutPut)
      if(MobOTP.IsSuccess){
        // this.toastr.success("OTP Validated Successfully");
        this.updateMobile();
        this.otptriggermob = false;
      }else{
        this.errorComp.ModalShow(MobOTP.Message);
        // this.toastr.error(MobOTP.Message);
        this.otpError = true;
      }
    }, error: _error =>{
      this.loader.stop();
      this.otpError = true;
      this.errorComp.ModalShow(_error.error.Message);
      // this.toastr.error(_error.error.Message)

    }
  });

}
key(event:KeyboardEvent){
  if(event.code === "Backspace"){
    this.back = true;
  }else{
    this.back = false;
  }
}

formatDateInput(event: any) {
  // setTimeout(() => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/\D/g, '');
  if (value.length >= 2 && value.length < 4 && !this.back) {
    value = value.slice(0, 2) + '/' + value.slice(2);
  }
   else if (value.length >= 4 && !this.back) {
    value = value.slice(0, 2) + '/' + value.slice(2, 4) + '/' + value.slice(4, 8);
  }
  input.value = value;
  if(input.value &&  this.isValidDate(input.value) && !this.back){
    const dobPartss = input.value.split('/');
    const years = +dobPartss[2];
    const months = +dobPartss[1];
    const days = +dobPartss[0];
    const jsDate = new Date(years, months - 1, days);
    const dateModel: IMyDateModel = {
      date: { year: years, month: months, day: days },
      formatted: input.value,
      epoc: Math.round(jsDate.getTime() / 1000),
      jsdate: jsDate
    };
    this.onDateChanged(dateModel);
  }
  // }, 100);
  
}




isValidDate(dateStr: string): boolean {
  const dateRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
  return dateRegex.test(dateStr);
}

validateMobileNumber() {
  const mobileNumber = this.nriMobile;


  const repeatedDigitRegex = /(.)\1{4,}/;
  if (repeatedDigitRegex.test(mobileNumber)) {
    this.errorComp.ModalShow("Please Enter Valid Mobile Number");
    // this.toastr.error("Please Enter Valid Mobile Number");
    return false;
  }

  return true; 
}

panResumeYes(){
  this.router.navigate(['/register']);
  sessionStorage.setItem("resumeJourney", "Resume");
  location.reload();
}
aadhar(status:string){
  if(status){
    if(status === "yes"){
      this.aadharClickYes = true;
      this.aadharClickNo = false;
      this.aadharStatus = true;
    }else{
      this.aadharClickNo = true;
      this.aadharClickYes = false;
      this.aadharStatus = false;
    }
  }
}

}
